export default __webpack_public_path__ + "static/media/letter.3ed4b472.svg";